import react, { PropsWithChildren, SyntheticEvent, useRef } from 'react';

import { useMediaQuery } from '@material-ui/core';
import { usePreviewContext } from '../context';

interface IProps {
  id: string;
  onTouch?: (event?: SyntheticEvent) => void;
  onClick?: (event?: SyntheticEvent) => void;
  children: react.ReactElement<any>;
}

const PreviewCardIddle = (props: PropsWithChildren<IProps>) => {
  const context = usePreviewContext();
  const delayClickRef = useRef<NodeJS.Timeout>(null);
  const isScreenLarge = useMediaQuery('(min-width: 960px)');

  const isMobile = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform.toLowerCase();
    const isIOS = /ipad|iphone|ipod|ios/.test(platform) || (userAgent.includes('mac') && 'ontouchend' in document);
    return /(ipad|tablet|mobi|(android(?!.*mobile)))/.test(userAgent) || isIOS;
  };

  const onClick = () => {
    if (!isMobile() && isScreenLarge) {
      return props.onClick();
    }
    delayClickRef.current = setTimeout(() => {
      props.onTouch();
      clearTimeout(delayClickRef.current);
    }, 250);
  };

  const cancelCardOpeningIfIsScrolling = () => {
    clearTimeout(delayClickRef.current);
  };

  const onMouseOut = () => {
    if (context.activeElement.target === null) {
      context.cancelTimeout();
    }
  };

  const onMouseEnter = (event: any) => {
    if (!isScreenLarge || isMobile()) return;
    context.setActiveElement({
      id: props.id,
      target: event.target,
    });
  };

  return (
    <div
      style={{ cursor: 'pointer' }}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
      onMouseMove={cancelCardOpeningIfIsScrolling}
      onMouseOut={onMouseOut}
    >
      <div style={{ pointerEvents: 'none' }}>{props.children}</div>
    </div>
  );
};

export default PreviewCardIddle;
